import { render, staticRenderFns } from "./Private.vue?vue&type=template&id=0efa2966"
import script from "./Private.vue?vue&type=script&lang=js"
export * from "./Private.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports